import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import styles from './CheckboxGroup.styles.esm.js';

const CheckboxGroup = (_a) => {
    var { className, children, legend } = _a, props = __rest(_a, ["className", "children", "legend"]);
    const classes = styles({
        class: className,
    });
    return (jsxs("fieldset", Object.assign({ className: classes }, props, { children: [legend && jsx("legend", { className: "iris:sr-only", children: legend }), children] })));
};
CheckboxGroup.displayName = "CheckboxGroup";

export { CheckboxGroup };
